import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useAppSelector } from "../app/hooks";
import { UserRole } from "../app/userSlice";

export default function RequireAdminSession() {
	const { school, district } = useAppSelector((state) => state.user);
	const role = useAppSelector((state) => state.user.role);

	const navigate = useNavigate();

	useEffect(() => {
		if (role === UserRole.SchoolAdmin && !school) {
			navigate("/selectSchool");
		}
	});
	useEffect(() => {
		if (role === UserRole.DistrictAdmin && !district) {
			navigate("/selectDistrict");
		}
	});

	return <Outlet />;
}
